function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 89,
  width: 12,
  height: 128,
  rx: 6,
  fill: "#BF980C"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 61,
  y: 29,
  width: 68,
  height: 12,
  rx: 6,
  fill: "#BF980C"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 158,
  r: 38,
  fill: "#6D9FFF"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 71,
  cy: 107,
  r: 38,
  fill: "#6090ED"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 158,
  r: 38,
  fill: "#6090ED"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 120,
  r: 38,
  fill: "#6090ED"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 158,
  r: 38,
  fill: "#6D9FFF"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 196,
    viewBox: "0 0 190 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.c4eeb53d.svg";
export { ForwardRef as ReactComponent };